<template>
  <div class="card">

    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          :showAddNew="false"
          title="IPD Sales-Collection Report"
      />
    </div>

    <div class="my-2 px-2">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label
              for="colFormLabel"
              class="col-form-label"
          >
            Date
          </label>
          <input
              @change="updateUrl"
              v-model="date"
              type="date"
              class="form-control date-mask"
              placeholder="From"
          >
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label
            for="colFormLabel"
            class="col-form-label"
          >
            Receipt by (User):
          </label>
          <v-select
            placeholder="Receipt by"
            :options="contactList"
            label="name"
            :reduce="(name) => name.id" v-model="created_by" />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-auto">
          <button
              style="min-width: 64px;"
              @click="getReport"
              class="btn btn-primary btn-block waves-effect waves-float waves-light"
          >
              Go
          </button>
        </div>
        </div>
      </div>

      <div class="d-flex justify-content-end px-2">
        <button
            @click="exportReport"
            class="btn btn-outline-secondary btn-sm mb-2"
        >Export
        </button>
      </div>

    <div class="col-12 px-2">
      <ListTable :lists="lists" :groupNames="groupNames"/>
    </div>
    <div class="mb-2"></div>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {useRoute, useRouter} from 'vue-router';
import ListTable from '@/components/molecule/company/hospital/hospital-admin/IpdSalesCollectionReportTable.vue';
import handleHospitalReport from "@/services/modules/hospital/report";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import {useStore} from "vuex";
import handleInventory from "@/services/modules/inventory";
import handleImportTracker from "@/services/modules/procurement/importTracker";

const {fetchIPDSalesCollectionReport} = handleHospitalReport()
const {fetchHome} = handleInventory()
const { fetchContacts } = handleImportTracker();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const store = useStore()
const route = useRoute();
const router = useRouter();
const loading = ref(false);
const business = ref([])
const lists = ref([])
const groupNames = ref({})
const date = ref()
const token = localStorage.getItem('token');
const contactList = ref([])
const created_by = ref(null)

//computed
const companyId = computed(() => route.params.companyId);
const dateValue = computed(() => route.query.date);

//methods
const getQuery = () => {
  let query = '?company_id=' + companyId.value
  if (created_by.value) query += `&created_by=${created_by.value}`
  if (dateValue.value) query += '&date=' + dateValue.value
  return query
};
const updateUrl = () => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.date = date.value
  router.push({path: route.path, query: routeQuery})
}
const getReport = () => {
  fetchIPDSalesCollectionReport(getQuery()).then(({status, ...rest}) => {
    if (!status) {
      lists.value = []
      return groupNames.value = {}
    }

    lists.value = rest.data
    groupNames.value = rest.group_names
  }).catch((err) => {
    loading.value = false
  }).finally(() => {
    loading.value = false
  })
};

const getContacts = () => {
  fetchContacts('?company_id=' + companyId.value).then(res => {
    if (res.data) {
      contactList.value = res.data;
    }
  }).catch(e => showError('Something went wrong'))
}

const exportReport = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/export/hospital/ipd-sales-collection-report${query}&_token=${token}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}

onMounted(async () => {
  date.value = route.query.date
  getReport()
  getContacts()
})
</script>
